import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202605/danzai-2026/Index.vue')
const PartyId = () => import('../activity/202605/danzai-2026/PartyId.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/danzai61/2026',
  name: 'activity_danzai61_2026',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '六一蹦跶计划',
    ignoreLogin: true,
  },
}

export const partyIdRoute: RouteConfig = {
  path: '/activity/danzai61/2026/party-id',
  name: 'activity_danzai61_2026_party_id',
  component: PartyId,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '填写ID',
    ignoreLogin: true,
  },
}

export default [indexRoute, partyIdRoute]
